document.addEventListener("DOMContentLoaded", function () {
	// Get all carousel elements
	const swipers = document.querySelectorAll(".swiper");

	swipers.forEach(function (swiperContainer) {
		// Get the carouselId from the swiper container
		const carouselId = swiperContainer.getAttribute("data-carousel-id");
		if (!carouselId) return; // Skip if no carousel ID is set

		// Retrieve other attributes from the swiper container
		const slidesGap =
			parseInt(swiperContainer.getAttribute("data-slides-gap"), 10) || 0;
		const imagesPerView =
			parseInt(swiperContainer.getAttribute("data-images-per-view"), 10) || 1;
		const autoPlay = swiperContainer.getAttribute("data-autoplay") === "true";
		const transitionEffect = swiperContainer.getAttribute(
			"data-transition-effect",
		);
		const transitionSpeed = parseInt(swiperContainer.getAttribute("data-transition-speed"), 10) || 300;
		const autoPlayDelay = autoPlay
			? parseInt(swiperContainer.getAttribute("data-autoplay-delay"), 10)
			: 3000;
		const isLoop = swiperContainer.getAttribute("data-loop") === "true";
		const enabledResponsive =
			swiperContainer.getAttribute("data-responsive") === "true";

		// Find the corresponding control elements using the carouselId
		// Look for pagination and navigation within the entire document
		const paginationEl = document.querySelector(
			`.custom-swiper-pagination[data-carousel-id="${carouselId}"]`,
		);
		const nextEl = document.querySelector(
			`.custom-next-button[data-carousel-id="${carouselId}"]`,
		);
		const prevEl = document.querySelector(
			`.custom-prev-button[data-carousel-id="${carouselId}"]`,
		);

		// Debug log when elements can't be found
		if (carouselId && (!paginationEl || !nextEl || !prevEl)) {
			console.log(`Carousel with ID ${carouselId} found, but some controls are missing:`, {
				pagination: !!paginationEl,
				next: !!nextEl,
				prev: !!prevEl
			});
		}

		// Initialize with default configuration
		let swiperConfig = {
			spaceBetween: slidesGap,
			slidesPerView: imagesPerView,
			loop: isLoop,
			lazy: true,
			speed: transitionSpeed,
			autoplay: autoPlay
				? {
						delay: autoPlayDelay,
						disableOnInteraction: false,
				  }
				: false,
			effect: transitionEffect !== "normal" ? transitionEffect : "",
			// Only add pagination if the element exists
			...(paginationEl && {
				pagination: {
					el: paginationEl,
					clickable: true,
					renderBullet: function (index, className) {
						return `<span class="${className}"></span>`;
					},
				},
			}),
			// Only add navigation if the elements exist
			...((nextEl || prevEl) && {
				navigation: {
					nextEl,
					prevEl,
				},
			}),
		};

		// Add responsive breakpoints if enabled
		if (enabledResponsive) {
			const mobileBreakpoint =
				parseInt(swiperContainer.getAttribute("data-mobile-breakpoint"), 10) ||
				640;
			const tabletBreakpoint =
				parseInt(swiperContainer.getAttribute("data-tablet-breakpoint"), 10) ||
				1024;
			const mobileImagesPerView =
				parseInt(
					swiperContainer.getAttribute("data-mobile-slides-per-view"),
					10,
				) || 1;
			const tabletImagesPerView =
				parseInt(
					swiperContainer.getAttribute("data-tablet-slides-per-view"),
					10,
				) || 2;

			swiperConfig.breakpoints = {
				// Mobile: from 0 to mobileBreakpoint
				0: {
					slidesPerView: mobileImagesPerView,
				},
				// Tablet: from mobileBreakpoint to tabletBreakpoint
				[mobileBreakpoint]: {
					slidesPerView: tabletImagesPerView,
				},
				// Desktop: from tabletBreakpoint up
				[tabletBreakpoint]: {
					slidesPerView: imagesPerView,
				},
			};
		}

		// Initialize Swiper with the complete configuration
		new Swiper(swiperContainer, swiperConfig);
	});
});
